<script>
import { mergeData } from 'vue-functional-data-merge';

import SelectCell from './cells/SelectCell.vue';
import IconCell from './cells/IconCell.vue';

export default {
  functional: true,
  inject: ['cssClasses'],
  props: {
    column: { type: Object, required: true },
    row: { type: Object, required: true },
    rowProp: { type: Object, required: false, default: () => ({}) },
    rowIndex: { type: Number, required: true },
  },
  render(createElement, {
    props, injections, data,
  }) {
    // console.log('createTableTd')
    const { cssClasses } = injections;
    const { row, column } = props;
    const { type } = column;

    const classes = {
      [cssClasses.cell]: true,
    };
    if (column.ellipsis) classes[cssClasses.cellEllipsis] = true;
    if (type === 'expand') classes[cssClasses.cellWithExpand] = true;

    const localData = {
      class: classes,
    };

    const cellComponent = ((renderType) => {
      switch (renderType) {
        case 'normal': {
          const spanData = column.ellipsis ? { attrs: { title: row[column.key] } } : {};
          return createElement('span', spanData, row[column.key]);
        }
        case 'html':
          return createElement('span', {
            domProps: {
              innerHTML: row[column.key],
            },
          });
        case 'icon': {
          const { opts = {}, key } = column;
          const { prop = key, tooltip } = opts;
          return row[prop] ? createElement(IconCell, {
            props: {
              ...opts,
              tooltip: tooltip ? row[prop] : undefined,
            },
          }) : createElement('span');
        }
        case 'render':
          return column.render(createElement, { column, row, index: props.rowIndex });
        case 'selection':
          return createElement(SelectCell, {
            props: { row, rowProp: props.rowProp },
          });
        case 'index':
          return createElement('span', props.rowIndex + 1);
        default:
          return createElement('span');
      }
    })(type);

    return createElement('div', mergeData(data, localData), [cellComponent]);
  },
};
</script>
